import Core            from "@/core/Core";
import DialogsService  from './DialogsService';
import DialogsRegistry from './DialogsRegistry';

/**
 * Утилитарные методы для работы с типовыми диалогами
 * Простые, понятные методы без лишних параметров
 */
class DialogsUtils {

	/**
	 * Показать простой диалог подтверждения
	 * @param message - Текст сообщения
	 * @param title - Заголовок диалога
	 * @returns Promise<boolean> - true если подтвердил, false если отменил
	 */
	public static async confirm(
		message: string,
		title: string = 'Подтверждение'
	): Promise<boolean> {
		const result = await this.showConfirmDialog(message, title, false);
		return result.isApproved;
	}

	/**
	 * Показать диалог подтверждения с вводом причины
	 * @param message - Текст сообщения
	 * @param title - Заголовок диалога
	 * @returns Promise с результатом и текстом причины
	 */
	public static async confirmWithReason(
		message: string,
		title: string = 'Подтверждение'
	): Promise<{ isApproved: boolean; reasonText: string }> {
		return this.showConfirmDialog(message, title, true);
	}

	/**
	 * Приватный метод для показа диалога подтверждения
	 * @param message - Текст сообщения
	 * @param title - Заголовок диалога
	 * @param showReason - Показывать поле для ввода причины
	 * @returns Promise с результатом
	 */
	private static showConfirmDialog(
		message: string,
		title: string,
		showReason: boolean
	): Promise<{ isApproved: boolean; reasonText: string }> {
		return new Promise(async (resolve) => {
			Core.dialogs.VApproveDialog.show(
				{ title, message, showReason },
				{
					approve: (reasonText: string) => {
						DialogsService.hide(DialogsRegistry.VApproveDialog);
						resolve({ isApproved: true, reasonText });
					},
					close: (reasonText: string) => {
						resolve({ isApproved: false, reasonText });
					}
				}
			);
		});
	}
}

export default DialogsUtils;
